import { kayaCRUD } from "../../../actions/kaya"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../actions/dictionary"
import Select from "react-select";

const personalSchema = Yup.object().shape({
  StartDate: Yup.date().default(() => new Date()),
  death_date: Yup.date().max(Yup.ref('StartDate'),"Date of death can't be after today").required('Date of death is required'),
  dictionary_death_causes: Yup.string().required('Death causes is required'),
});

const initialValues = {
  dictionary_death_causes: '',
  death_date: '',
  is_dead: true,
  death_detail: '',
}

export const DeadMember = (props) => {

  const {setIndex, index, dataId} = props

  
  const [loading, setLoading] = useState(false)
  const [death, setDeath] = useState([])

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryData(50, 0, '', 24).then((resp) => {
        setDeath(resp.data.results)
      }).finally(() => {})
    }, 500)
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: personalSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { dictionary_death_causes, death_date, is_dead, death_detail } = values
      const data = { dictionary_death_causes, death_date, is_dead, death_detail }
      setLoading(true)
      setTimeout(() => {
        kayaCRUD.updateDeadMember(dataId, data).then(() => {
          toast.success('New Member death has been registered.', { autoClose: 7000 })
          setIndex(index+1)
          setLoading(false)
          setSubmitting(false)
          resetForm()
        }).catch((error) => {
          toast.error(error.message, { autoClose: 7000 })
          setLoading(false)
          setSubmitting(false)
        })
      }, 1000)
    }
  })


  return (
    <>
      <div className="modal fade deadModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="myLargeModalLabel">Dead House Hold Member</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="death_date" className="form-label">Death Date <span className="text-danger">*</span></label>
                      <input type="date" id="death_date" {...formik.getFieldProps('death_date')} className="form-control" placeholder="Head Phone Number" />
                      {formik.touched.death_date && formik.errors.death_date && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.death_date}</span>
                        </div>
                      )}
                    </div>
                  </div>
                <div className="col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label for="dictionary_death_causes" class="form-label">Death Causes <span className="text-danger">*</span></label>
                      <Select
                        options={
                          death?.map((dt) => (
                            {value : dt.id, label : dt.dictionary_item_name_en}
                          ))
                        }
                        placeholder="Select Death causes"
                        onChange={(e) => formik.setFieldValue('dictionary_death_causes', e.value)}
                        isSearchable={true}
                      />
                      {formik.touched.dictionary_death_causes && formik.errors.dictionary_death_causes && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary_death_causes}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                  <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label for="death_detail" className="form-label">Description </label>
                      <textarea type="text" rows={5} id="death_detail" {...formik.getFieldProps('death_detail')} className="form-control" placeholder="Description"></textarea>
                      {formik.touched.death_detail && formik.errors.death_detail && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.death_detail}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div className="modal-footer">
                <a href="javascript:void(0);" class="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i class="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}